import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import MetricScreen from "../../components/Admin/Metric-Screen/MetricScreen";

const MetricDictionaryPage: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-[#F7F7FF]">
      <div className="flex-grow">
        <Header />
        <main className="mx-10 mt-10 font-poppins">
          <h1 className="text-2xl font-bold text-gray-700 mb-6">Metric Dictionary</h1>
          <MetricScreen />
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default MetricDictionaryPage;